import React from "react";
import { FaRegCalendarAlt } from "react-icons/fa";
import { Link } from "react-router-dom";
import { toThaiDate } from "../utils/globalFunctions";
import ImageWithTooltip from "./ImageWithTooltip";

const NewsCard = ({ url, image, title, datetime }) => {
  return (
    <Link to={url} className="card w-[320px]">
      <div className="card-body">
        <div className="">
          <ImageWithTooltip
            src={image}
            alt={title}
            className="rounded-lg h-[150px] w-full object-cover"
          />
        </div>
        <div className="flex gap-2 items-center">
          <FaRegCalendarAlt />
          <span>{toThaiDate(datetime)}</span>
        </div>
        <div className=" text-dark-600 text-lg line-clamp-3">{title}</div>
      </div>
    </Link>
  );
};

export default NewsCard;
